<template>
<nav>
  <ul class="basic-menu clearfix">
    <li v-for="(link, text) in navigation"  v-bind:key="text">
      <router-link :to="link">{{text}}</router-link>
    </li>
  </ul>
</nav>			
</template>

<script>
export default {
  name: "DesktopNav",
  props: ['navigation']
}
</script>